import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetch: (config: AxiosRequestConfig) => api.get("/invoices", config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/invoices/${url.id}`, config),
};

export default requests;
